import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import apiService from './api.service';
import { getSFxUser } from '../utils/checkSFxRoleAuth';
import { replaceParamVal } from './accountSetting.api';
var UrlList = {
  apiGetUserData: '/api/User/profiles',
  apiSaveUserData: '/api/User/profiles',
  uploadAvatarImgUrl: "/api/User/UploadAvatar/${orgId}/${userId}",
  deleteAvatarImgUrl: "/api/User/avatar/${orgId}/${userId}",
  getCountryUrl: '/api/geo/country',
  getTimeZoneUrl: '/api/geo/timezones/${countryCode}',
  getProvinceUrl: '/api/geo/${countryId}/state',
  getCityUrl: '/api/geo/${stateId}/city',
  getCountryCodeListUrl: '/api/geo/callingcodes',
  changePasswordUrl: '/api/User/updatepassword',
  setSecurityQuestionUrl: '/api/user/questions/answers',
  getAllSecurityQuestionListUrl: '/api/User/questions',
  getUserSecurityQuestionListUrl: '/api/user/associatedquestions',
  checkAnswerUrl: '/api/user/answers/check'
};
var user; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export var initUserProfileApi = function initUserProfileApi(data) {
  user = getSFxUser(data);
  user = _objectSpread(_objectSpread({}, data), user);

  if (data.api) {
    UrlList = _objectSpread(_objectSpread({}, UrlList), data.api);
  }
};
export var getUserInfo = function getUserInfo(opts) {
  var _user = user,
      userId = _user.userId;
  var url = replaceParamVal(UrlList.apiGetUserData, {
    userId: userId
  });
  return apiService.get(url, {}, opts);
};
export var getCountry = function getCountry(opts) {
  return apiService.get(UrlList.getCountryUrl, {}, opts);
};
export var getTimeZone = function getTimeZone(countryCode, opts) {
  var url = replaceParamVal(UrlList.getTimeZoneUrl, {
    countryCode: countryCode
  });
  return apiService.get(url, {}, opts);
};
export var getProvince = function getProvince(countryId, opts) {
  var url = replaceParamVal(UrlList.getProvinceUrl, {
    countryId: countryId
  });
  return apiService.get(url, {}, opts);
};
export var getCity = function getCity(stateId, opts) {
  var url = replaceParamVal(UrlList.getCityUrl, {
    stateId: stateId
  });
  return apiService.get(url, {}, opts);
};
export var getCountryCodeList = function getCountryCodeList(opts) {
  return apiService.get(UrlList.getCountryCodeListUrl, {}, opts);
};
export var changePassword = function changePassword(params, opts) {
  return apiService.put(UrlList.changePasswordUrl, params, opts);
};
export var setSecurityQuestion = function setSecurityQuestion(params, opts) {
  return apiService.post(UrlList.setSecurityQuestionUrl, params, opts);
};
export var getAllSecurityQuestionList = function getAllSecurityQuestionList() {
  return apiService.get(UrlList.getAllSecurityQuestionListUrl, {}, {
    catchError: true
  });
};
export var getUserSecurityQuestionList = function getUserSecurityQuestionList() {
  var _user2 = user,
      userId = _user2.userId;
  var url = replaceParamVal(UrlList.getUserSecurityQuestionListUrl, {
    userId: userId
  });
  return apiService.get(url, {}, {
    catchError: true
  });
};
export var checkAnswer = function checkAnswer(params, opts) {
  return apiService.post(UrlList.checkAnswerUrl, params, opts);
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export var saveUserData = function saveUserData(params, opts) {
  var _user3 = user,
      userId = _user3.userId;
  var url = replaceParamVal(UrlList.apiSaveUserData, {
    userId: userId
  });
  return apiService.post(url, params, opts);
};
export var uploadAvatar = function uploadAvatar(data, opts) {
  var _user4 = user,
      orgId = _user4.orgId,
      userId = _user4.userId;
  var url = replaceParamVal(UrlList.uploadAvatarImgUrl, {
    orgId: orgId,
    userId: userId
  });
  return apiService.post(url, data, opts);
};
export var deleteAvatar = function deleteAvatar(opts) {
  var _user5 = user,
      orgId = _user5.orgId,
      userId = _user5.userId;
  var url = replaceParamVal(UrlList.deleteAvatarImgUrl, {
    orgId: orgId,
    userId: userId
  });
  return apiService.delete(url, {}, opts);
};